import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useGetQuotaUsageSuspenseQuery = () => {
    const { getQuotaUsage } = useAiApiClient();

    return useSuspenseQuery({
        queryKey: AiQueryKeys.GetQuotaUsage(),
        queryFn: async() => {
            const data = await getQuotaUsage();

            return data;
        }
    });
};
